module.exports = __webpack_public_path__ + "static/img/Travis_Boak_mobile.4d82881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Travis_Boak_mobile.jpg
// module id = htpm
// module chunks = 0